import { Badge } from "@/components/ui/badge"
import type { RunRow } from "@/types/run"

/**
 * A dry run and a redirected run both look like real sends in a table of
 * numbers. Neither may ever be left implicit, so both get a badge that is
 * always rendered when it applies.
 */
export function RunBadges({ run }: { run: RunRow }) {
  return (
    <>
      {run.was_dry_run ? (
        <Badge tone="signal">Rehearsal</Badge>
      ) : (
        <Badge tone="accent">Live send</Badge>
      )}
      {run.redirected_to && <Badge tone="neutral">Redirected</Badge>}
      {run.status !== "completed" && (
        <Badge tone={run.status === "running" ? "muted" : "danger"}>
          {run.status_label}
        </Badge>
      )}
      {run.status === "completed" && run.failed_count > 0 && (
        <Badge tone="danger">
          {run.failed_count.toLocaleString()} failed
        </Badge>
      )}
    </>
  )
}
